<template>
  <button
    type="button"
    class="toggle-switch"
    :class="{ on: value, busy }"
    role="switch"
    :aria-checked="value ? 'true' : 'false'"
    :aria-label="label"
    :title="title || label"
    :disabled="disabled || busy"
    @click.stop="$emit('change', !value)"><span></span></button>
</template>

<script>
/**
 * On/off switch (the onboarding board's style). Emits `change` with the new
 * value; the parent saves it and passes `value` back.
 */
export default {
  name: 'ToggleSwitch',
  props: {
    value: { type: Boolean, default: false },
    label: { type: String, required: true },
    title: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
    busy: { type: Boolean, default: false }
  }
}
</script>

<style scoped>
.toggle-switch { position: relative; flex: 0 0 auto; width: 36px; height: 21px; padding: 0; border: 1px solid #434857; border-radius: 99px; background: rgba(8, 11, 17, 0.72); cursor: pointer; transition: background 0.15s, border-color 0.15s; }
.toggle-switch span { position: absolute; top: 3px; left: 3px; width: 13px; height: 13px; border-radius: 50%; background: #9198aa; transition: transform 0.15s, background 0.15s; }
.toggle-switch.on { border-color: #1bc98e; background: rgba(27, 201, 142, 0.18); }
.toggle-switch.on span { transform: translateX(15px); background: #1bc98e; }
.toggle-switch:focus-visible { outline: 2px solid rgba(127, 208, 238, 0.6); outline-offset: 2px; }
.toggle-switch:disabled { cursor: not-allowed; opacity: 0.5; }
.toggle-switch.busy { cursor: progress; opacity: 0.7; }
</style>
